import { Sparkles } from 'lucide-react';
import { AiGenerateWithPromptDialog } from '@/components/ai-job/AiGenerateWithPromptDialog';

interface GenerateConclusionActionProps {
  tourId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Dialog that generates a conclusion for a tour.
 */
export function GenerateConclusionAction({ tourId, open, onOpenChange }: GenerateConclusionActionProps) {
  return (
    <AiGenerateWithPromptDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Generate Conclusion"
      description={
        <>
          This will generate a conclusion based on the tour&apos;s description,
          attractions, and highlights. Any existing conclusion will be overwritten.
        </>
      }
      endpoint={`/tours/${tourId}/generate-conclusion`}
      promptPurpose="tour_conclusions"
      invalidateKeys={[['Tour', tourId]]}
      successMessage="Conclusion generated successfully"
      errorFallback="Failed to generate conclusion"
    />
  );
}

/** Icon used for the Generate Conclusion action button. */
export const GenerateConclusionIcon = Sparkles;
